const DENIED_REASONS = {
    PAGE_PERMISSION_NOT_GRANTED: {
        title: '暂无访问权限',
        description: '请联系应用负责人开通。',
    },
    PAGE_NOT_REGISTERED: {
        title: '页面未接入权限管理',
        description: '请联系应用负责人同步页面。',
    },
    PAGE_CATALOG_UNSYNCED: {
        title: '应用页面未同步',
        description: '请联系应用负责人同步页面。',
    },
    PARTNER_ACCESS_NOT_CONFIGURED: {
        title: '应用未开放访问',
        description: '请联系应用负责人开通。',
    },
}

const DEFAULT_DENIED_REASON = {
    title: '暂无访问权限',
    description: '请联系应用负责人确认。',
}

export const getDeniedReasonContent = reason => DENIED_REASONS[reason] || DEFAULT_DENIED_REASON

export const shouldPromptRouteResync = reason => reason === 'PAGE_NOT_REGISTERED'

const ROUTE_SETUP_REASONS = new Set(['PAGE_NOT_REGISTERED', 'PAGE_CATALOG_UNSYNCED'])

export const getDeniedReasonAction = reason => ROUTE_SETUP_REASONS.has(reason)
    ? {
        requestLabel: '提醒负责人处理',
        submittedLabel: '已提醒负责人',
        requestHint: '发送钉钉提醒，请负责人同步页面',
        guideTitle: '下一步',
        steps: ['提醒负责人同步页面。', '同步后重新检查。'],
    }
    : {
        requestLabel: '申请访问权限',
        submittedLabel: '申请已发送',
        requestHint: '发送钉钉开通权限消息',
        guideTitle: '申请页面权限',
        steps: ['提交申请，通知负责人。', '开通后重新检查。'],
    }

export { buildAccessRequestText } from './vibeOwnerAccessStatus'
